import { FC } from 'react';
import styled, { css } from 'styled-components';

const ContainerSmall: FC<any> = ({
	children,
	marketingSolutions,
	viberForBusiness,
	messagingSolutions,
	successStories,
	privacy,
}) => (
	<Wrapper
		$privacy={privacy}
		$successStories={successStories}
		$marketingSolutions={marketingSolutions}
		$viberForBusiness={viberForBusiness}
		$messagingSolutions={messagingSolutions}
	>
		{children}
	</Wrapper>
);

const Wrapper = styled.div<{
	$privacy?: boolean;
	$successStories?: boolean;
	$marketingSolutions?: boolean;
	$viberForBusiness?: boolean;
	$messagingSolutions?: boolean;
}>`
	width: 960px;
	max-width: 100%;
	margin: 0 auto;

	${({ $viberForBusiness, $marketingSolutions, $privacy }) =>
		($viberForBusiness || $marketingSolutions || $privacy) &&
		css`
			width: 1180px;
			max-width: 100%;

			@media (max-width: 1900px) {
				width: 990px;
				max-width: 100%;
			}

			@media (max-width: 1440px) {
				width: 960px;
				max-width: 100%;
			}
		`}
`;

export default ContainerSmall;
